import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { withRouter, Link } from "react-router-dom"
import { isEmpty, result, size } from "lodash"
import * as moment from "moment"
import BootstrapTable from "react-bootstrap-table-next"
import classNames from "classnames"
import { AvForm, AvField } from "availity-reactstrap-validation"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import {showSuccessToast} from "helpers/function_helper"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Badge,
  UncontrolledTooltip,
  UncontrolledDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap"
import RightDrawer from "../../components/Common/RightDrawer"
//redux
import { useSelector, useDispatch } from "react-redux"
import SweetAlert from "react-bootstrap-sweetalert"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
//import PurchasePaymentListDetails from "pages/Sales/PurchasePaymentListDetails"
import { getPurchasePaymentList } from "helpers/backend_helper"
import { deleteItemDirect as onDeleteItemDirect } from "helpers/backend_helper"
import { deletePurchasePaymentEntry } from "helpers/backend_helper"

import { editItemDirect as onEditItemDirect } from "helpers/backend_helper"
import Loader from "components/Common/Loader"
//import SalesListFilter from "../../components/Common/SalesListFilter"

const PurchasePaymentList = props => {

  useEffect(() => {
    getPurchasePayments()
  }, []);

  async function getPurchasePayments(){
    setShowLoading(true)
    getPurchasePaymentList().then(result => {
      setPurchasePaymentList(result)
      setShowLoading(false)
    })
  }

  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [currentReceipt, setCurrentReceipt] = useState({})

  const [purchasePaymentList, setPurchasePaymentList] = useState([])
  const [selectedRow, setSelectedRow] = useState()

  const [searchInProgress, setSearchInProgress] = useState(false)

  const [showDeletePopUp, setShowDeletePopUp] = useState(false)
  const [showErrorPopUp, setShowErrorPopUp] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [deleteMessage, setDeleteMessage] = useState('')
  const [itemToDelete, setItemToDelete] = useState()
  const [showLoading, setShowLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  
  const [showReceipt, setShowReceipt] = useState(false)

  //pagination customization
  const pageOptions = {
    sizePerPage: 20,
    totalSize: size(purchasePaymentList), 
    custom: true,
    onPageChange: (page, sizePerPage) => {
      setCurrentPage(page)
    }
  }

  const { SearchBar } = Search

  const handleValidDate = date => {
    const date1 = moment(new Date(date)).format("DD MMM Y")
    return date1
  }

  const PurchasePaymentListColumns = () => [
    {
      dataField: "id",
      text: "#",
      sort: true,
      sortValue: (cell, row) => Number(cell),
    },
    {
      dataField: "receiptdate",
      text: "Receipt Date",
      sort: true,
      formatter: (cellContent, row) => handleValidDate(cellContent),
      filterValue: (cellContent, row) => handleValidDate(cellContent),
    },
    {
      dataField: "invoiceno",
      text: "Supp. Invoice #",
      sort: true,
      //sortValue: (cell, row) => Number(cell),
    },
    {
      dataField: "customername",
      text: "Supplier Name",
      sort: true,
    },
    {
      dataField: "amount",
      text: "Amount",
      sort: true,
      formatter: (cellContent, row) => (
        <div>
          {Number(cellContent).toLocaleString('en-IN',{minimumFractionDigits: 2})}
          {Number(row.writeoff) > 0 ? <><br/><span className="text-muted font-size-12">Write Off: {Number(row.writeoff).toLocaleString('en-IN',{minimumFractionDigits: 2})}</span></> : null}
        </div>
        
        ),
      
    },
    {
      dataField: "action",
      isDummyField: true,
      text: "Action",
      formatter: (cellContent, item) => (
        <>

        {<UncontrolledDropdown>
          <DropdownToggle
            href="#"
            className="card-drop pointer-cursor"
            tag="i"
            onClick={(e) => {e.stopPropagation()}}
          >
            <i className="mdi mdi-dots-horizontal font-size-18" />
          </DropdownToggle>
          <DropdownMenu className="dropdown-menu-end">
            <DropdownItem
              onClick={() => handleEditClick(item)}
            >
              <i className="mdi mdi-pencil font-size-16 text-success me-1" />{" "}
              Edit
            </DropdownItem>
            <DropdownItem
              onClick={() => handleDeleteClick(item)}
            >
              <i className="bx bx-trash-alt font-size-16 text-danger me-1" />{" "}
              Delete
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
        }
        </>
      ),
    },
  ]

  const handleDeleteClick = arg => {
    setItemToDelete(arg)
    setDeleteMessage(arg.invoiceno)
    setShowDeletePopUp(true)
  }

  const confirmDelete = async () =>{
    setShowDeletePopUp(false)
    setShowLoading(true)
    const response =  await deletePurchasePaymentEntry(itemToDelete)
    setShowLoading(false)
    if(response.status == 'success'){
      showSuccessToast('Deleted Successfully!!!')
      getPurchasePayments()
    }
    else if(response.status == 'failure'){
      setErrorMessage(response.errorResponse)
      setShowErrorPopUp(true)
    }
  }

  const selectRow = {
    mode: 'radio',
    hideSelectColumn: true,
    clickToSelect: true,
    bgColor: '#e8e2d7',
    onSelect: (row, isSelect, rowIndex, e) => {
      setSelectedRow(row)
      setShowReceipt(true)
    }
  };

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ]

  function hideReceipt(){
    setShowReceipt(false)
  }

  const [filterApplied, setFilterApplied] = useState(false)
  const [searchCriteria, setSearchCriteria] = useState({})
  const [searchDispCriteria, setSearchDispCriteria] = useState({
    customername: 'All',
    status : 'Any'
  })

  function onSearch(searchCritiria){
    setSearchCriteria(searchCritiria)
    setSearchInProgress(true)
    getPurchasePaymentList(searchCritiria).then(result => {
      setPurchasePaymentList(result)
      setSearchInProgress(false)
    })
  }

  const toggle = () => {
    setModal(!modal)
  }

  const handleEditClick = arg => {
    const order = arg

    setCurrentReceipt({
      id: order.id,
      amount: order.amount,
      customername: order.customername,
      invoiceno: order.invoiceno,
      receiptdate: order.receiptdate,
      salesid: order.salesid,
    })

    setIsEdit(true)

    toggle()
  }

  const handleValidOrderSubmit = async(e, values) => {
    if (isEdit) {
      const input = {
        id: currentReceipt.salesid,
        receiptid: currentReceipt.id,
        amountallocated: values.amount,
        cashreceived: currentReceipt.amount,
      }
      toggle()
      setShowLoading(true)
      const response = await onEditItemDirect(input, 'PurchasePaymentEntry')
      if(response && response.status === 'failure'){
        //setShowErrorPopUp(true)
        //setErrorMessage(response.errorResponse)
      }
      else if(response && response.status === 'success'){
        showSuccessToast('Edited Successfully!!!')
        getPurchasePayments()
        //setShowSuccessPopUp(true)
        //setSuccessMessage('Sales Entry Updated successfully.')
      }
      setShowLoading(false)
    } 
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>View All Purchase Payments | Flamingo</title>
        </MetaTags>
        {!showReceipt && <Container fluid>
          <Breadcrumbs title="Purchase" breadcrumbItem="All Purchase Payments" />
          <Loader showLoader={showLoading} />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="id"
                    columns={PurchasePaymentListColumns()}
                    data={purchasePaymentList}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="id"
                        data={purchasePaymentList}
                        columns={PurchasePaymentListColumns()}
                        bootstrap4
                        search
                      >
                        {toolkitProps => (
                          <React.Fragment>
                            <Row className="mb-2">
                              <Col sm="6">
                              <div className={classNames({"d-none": currentPage !== 1},"search-box me-2 mb-2 d-inline-block")}>
                                  <div className="position-relative">
                                    <SearchBar {...toolkitProps.searchProps} />
                                    <i className="bx bx-search-alt search-icon" />
                                  </div>
                                </div>
                              </Col>
                              <Col sm="6">
                                <div className="text-sm-end">
                                  <Link
                                    to="/add-purchase-payment"
                                    role="button"
                                    className="btn btn-success btn-rounded  mb-2 me-2"
                                  >
                                    <i className="mdi mdi-plus me-1" />
                                    Add New Payment
                                  </Link>
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive min-height-200">
                                  <BootstrapTable
                                    keyField="id"
                                    responsive
                                    //selectRow={selectRow}
                                    bordered={false}
                                    striped={false}
                                    //defaultSorted={defaultSorted}
                                    classes={
                                      "table align-middle table-hover"
                                    }
                                    headerWrapperClasses={"table-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                    noDataIndication={<div className="text-center">- No results found -</div>}
                                  />
                                </div>

                                <Modal isOpen={modal} toggle={toggle}>
                                  <ModalHeader toggle={toggle} tag="h4">
                                    Edit Payment
                                  </ModalHeader>
                                  <ModalBody>
                                    <AvForm
                                      onValidSubmit={handleValidOrderSubmit}
                                    >
                                      <Row form>
                                        <Col className="col-12">
                                          <div className="mb-3">
                                            <AvField
                                              name="receiptdate"
                                              label="Date"
                                              type="date"
                                              disabled={true}
                                              errorMessage="Invalid Date"
                                              validate={{
                                                required: { value: true },
                                              }}
                                              value={moment(currentReceipt.receiptdate).format("YYYY-MM-DD") || ""}
                                            />
                                          </div>
                                          <div className="mb-3">
                                            <AvField
                                              name="customername"
                                              label="Supplier Name"
                                              type="text"
                                              disabled={true}
                                              errorMessage="Invalid Name"
                                              validate={{
                                                required: { value: true },
                                              }}
                                              value={currentReceipt.customername || ""}
                                            />
                                          </div>
                                          <div className="mb-3">
                                            <AvField
                                              name="invoiceno"
                                              label="Invoice No."
                                              disabled={true}
                                              type="text"
                                              errorMessage="Invalid No"
                                              validate={{
                                                required: { value: true },
                                              }}
                                              value={currentReceipt.invoiceno || ""}
                                            />
                                          </div>
                                          <div className="mb-3">
                                            <AvField
                                              name="amount"
                                              label="Amount"
                                              type="text"
                                              errorMessage="Invalid Amount"
                                              validate={{
                                                required: { value: true },
                                                pattern: {
                                                  value: "^[0-9]+?(\.[0-9]{0,2})?$",
                                                  errorMessage: "Please enter a valid amount",
                                                },
                                              }}
                                              value={currentReceipt.amount || ""}
                                            />
                                          </div>
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col>
                                          <div className="text-end">
                                            <button
                                              type="submit"
                                              className="btn btn-success save-user"
                                            >
                                              Save
                                            </button>
                                          </div>
                                        </Col>
                                      </Row>
                                    </AvForm>
                                  </ModalBody>

                                </Modal>
                              </Col>
                            </Row>
                            <Row className="align-items-md-center mt-30">
                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </Col>
                            </Row>
                          </React.Fragment>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>}

        {/*showReceipt && <PurchasePaymentListDetails 
        purchasePaymentList={purchasePaymentList} 
        selectedRow={selectedRow} 
        filterApplied={filterApplied}
        searchCriteria={searchCriteria}
        searchDispCriteria={searchDispCriteria}
        hideReceipt={hideReceipt}/>
        */}

      </div>

      {showDeletePopUp ? (
        <SweetAlert
          title="Are you sure?"
          warning
          showCancel
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            confirmDelete()
          }}
          onCancel={() => {
            setShowDeletePopUp(false)
          }}
        >
          <p>Deleting Payment entry for : <b>{deleteMessage}</b></p>
          You won't be able to revert this!
        </SweetAlert>
      ) : null}
      {showErrorPopUp ? (
        <SweetAlert
          error
          title="Failed"
          onConfirm={() => {
            setShowErrorPopUp(false)
          }}
        >
          {errorMessage}
        </SweetAlert>
      ) : null}
    </React.Fragment>
  )
}

PurchasePaymentList.propTypes = {
  purchasePaymentList: PropTypes.array,
}

export default withRouter(PurchasePaymentList)
